import React, { useEffect, useState } from 'react';
import DataTable from '../../../components/DataTable/DataTable';
import { IColInfo } from '../../../components/DataTable/Interfaces';
import { ApplicationFunctions, useAuth } from '../../../contexts/authContext';
import { useNotifications } from '../../../contexts/notificationContext';
import ProjectUserModel from '../../../models/ProjectUserModel';
import DataService from "../../../services/data.service";
import { UserProps } from '../../../types/IdProps';
import AddToProjectPopup from '../Popups/User_popup_AddToProject';


const User_tab_Projects: React.FC<UserProps> = ({ userId }) => {
    const [data, setData] = useState<ProjectUserModel[]>();
    const [showPopup, setShowPopup] = useState<boolean>(false)
    const { handleResult, handleException } = useNotifications();
    const { isAuthorizedFor } = useAuth();

    useEffect(() => {
        getTableData();
    }, [userId]);

    function getTableData() {
        DataService.get<ProjectUserModel[]>('api/v1/ProjectUsers/ByUser/' + userId)
            .then(response => {
                setData(response);
            })
            .catch(e => { handleException(e); });
    }

    function deleteRow(rowData) {
        DataService.delete('api/v1/ProjectUsers/', rowData.id)
            .then(response => {
                handleResult(response);
                getTableData();
            })
            .catch(e => { handleException(e); });
    }

    const colInfos: IColInfo[] = [
        { key: true, dataProp: 'projectId', visible: false },
        { title: 'Role', dataProp: 'functionalRole.name', sort: 'asc' },
        { title: 'Project', dataProp: 'project', dataType: 'project' },
        { title: 'Project type', dataProp: 'project.projectType' },
        { title: 'Status', dataProp: 'project.projectStatus' },
        { title: 'Started on', dataProp: 'project.startedOn', dataType: 'date' },
        { title: 'Deadline', dataProp: 'project.deadline', dataType: 'date' },
        { title: 'Finished on', dataProp: 'project.finishedOn', dataType: 'date' },
    ];

    if (isAuthorizedFor(ApplicationFunctions.UpdateUser)) {
        colInfos.push(
            {
                headerButtons: [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: () => setShowPopup(true) }],
                rowButtons: [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteRow }]
            }
        );
    }

    return (
        <>
            <DataTable
                name='dtUserProjects'
                colInfos={colInfos}
                tableData={data}
                navigateTitle='Project'
                navigateUrl='/plm/Projects/Details/'
            />
            <AddToProjectPopup userId={userId} show={showPopup} onHide={() => { setShowPopup(false); getTableData(); }} />

        </>
    );
}
export default User_tab_Projects;